<style>
.table-dashboard thead tr td {
    background: #1f2248;
    color: #fff;
}
.table-dashboard tfoot tr td {
    background: #1f2248;
    color: #fff;
}
.new-pemungut{
    border-bottom: 1px solid #000000 !important;
}
</style>
<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="PRESTASI BAGI KUTIPAN PATUT KUTIP MENGIKUT DAERAH">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.tarikh_hingga"
                            required
                            label="Hingga"
                            type="date"
                        />
                        <z-lookup
                            label="Kod Akaun"
                            :url="service_laporan + 'lookup/akaun_prestasi_petak'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.akaun_id"
                        />
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>

            <center v-if="loading == true"><w-progress class="ma1" circle></w-progress></center>
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr>
                                <td>DAERAH</td>
                                <td>ANGGARAN PEJABAT KEWANGAN NEGERI (RM)</td>
                                <td>JUMLAH PATUT KUTIP (RM)</td>
                                <td>KUTIPAN SEBENAR (RM)</td>
                                <td>PERATUS (%) ANGGARAN</td>
                                <td>PERATUS (%) PATUT KUTIP</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <td style="text-align: left">{{ dt.daerah }}</td>
                                    <td style="text-align: right">{{ dt.anggaran }}</td>
                                    <td style="text-align: right">{{ dt.patut_kutip }}</td>
                                    <td style="text-align: right">{{ dt.kutipan_sebenar }}</td>
                                    <td style="text-align: right">{{ dt.peratus_anggaran }}</td>
                                    <td style="text-align: right">{{ dt.peratus_patut_kutip }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="6" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><b>JUMLAH</b></td>
                                <td style="text-align: right"><b>{{table.jml_anggaran}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_patut_kutip}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_kutipan_sebenar}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_peratus_anggaran}}</b></td>
                                <td style="text-align: right"><b>{{table.jml_peratus_patut_kutip}}</b></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </w-flex>

            <w-flex class="mt1 mb3" justify-center>
                <div class="mt2 text-center">
                    <w-button bg-color="success" class="mr3" @click="cetak()">
                        <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                    </w-button>
                </div>
            </w-flex>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
        auth: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_laporan + "kutipan/laporan/dummy",
            reload: true,
            loading: false,
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan/laporan/prestasi_mengikut_daerah" },
                { label: "Laporan", route: "/kutipan/laporan/prestasi_mengikut_daerah" },
                {
                    label: "Prestasi Bagi Kutipan Patut Kutip Mengikut Daerah",
                    route: "/kutipan/laporan/prestasi_mengikut_daerah",
                },
            ],
            cari: { tarikh_dari: "", tarikh_hingga: "", akaun_id: "" },
        };
    },
    methods: {
        search() {
            this.getQueryData();
        },
        reset() {
            this.cari = { tarikh_dari: "", tarikh_hingga: "", akaun_id: "" };
            this.search();
        },

        cetak() {
            window.open(this.service_laporan+'kutipan/laporan/prestasi_mengikut_daerah?cetak=1&user_id='+this.auth.user.id+
            "&tarikh_dari=" + this.cari.tarikh_dari +
            "&tarikh_hingga=" + this.cari.tarikh_hingga +
            "&akaun_id=" + this.cari.akaun_id,'_blank');
            },
        async getQueryData() {
            this.loading = true;
            const resp = await axios.get(
                this.service_laporan + "kutipan/laporan/prestasi_mengikut_daerah?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga +
                    "&akaun_id=" + this.cari.akaun_id
            );
            this.table = resp.data;
            this.loading = false;
        },
    },
    watch: {},
    mounted() {
        // override default setting
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.tarikh_dari == "undefined") {
            this.cari.tarikh_dari = "";
        }
        if (this.cari.tarikh_hingga == "undefined") {
            this.cari.tarikh_hingga = "";
        }
        if (this.cari.akaun_id == "undefined") {
            this.cari.akaun_id = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
